export enum LayoutModels {	
	FULL_WIDTH = 'FULL_WIDTH',	
	NO_LAY_OUT = 'NO_LAY_OUT',
	NO_NAVIGATION = 'NO_NAVIGATION',
}
